import * as Yup from 'yup';

export const EditEnquiryDetailsSchema = Yup.object().shape({
  userReference: Yup.string().label('User reference').required(),
  expireAt: Yup.string().label('Expiry date').required()
});
